import { Bar } from "react-chartjs-2";
import { useRef, useState, useEffect } from "react";

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: "#616161",
        font: { size: 12 },
        boxWidth: 12,
        boxHeight: 12,
        borderRadius: 4,
      },
    },
    tooltip: {
      backgroundColor: "#1e293b",
      titleColor: "#f1f5f9",
      bodyColor: "#94a3b8",
      borderColor: "transparent",
      borderWidth: 0,
      padding: 12,
      cornerRadius: 10,
      displayColors: false,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: "#9e9e9e", font: { size: 11 } },
      border: { color: "transparent" },
    },
    y: {
      grid: { color: "rgba(0,0,0,0.04)", drawBorder: false },
      ticks: { color: "#9e9e9e", font: { size: 11 } },
      border: { color: "transparent", dash: [4, 4] },
      min: 0,
    },
  },
};

const gradientPlugin = {
  id: "gradientBars",
  beforeDatasetsDraw(chart) {
    const { ctx, chartArea } = chart;
    if (!chartArea) return;
    const { top, bottom } = chartArea;
    chart.data.datasets.forEach((dataset) => {
      const gradient = ctx.createLinearGradient(0, top, 0, bottom);
      gradient.addColorStop(0, "rgba(26, 115, 232, 1)");
      gradient.addColorStop(1, "rgba(26, 115, 232, 0.25)");
      dataset.backgroundColor = gradient;
      dataset.hoverBackgroundColor = "rgba(26, 115, 232, 0.9)";
    });
  },
};

const BarChart = ({ Data, options, label }) => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    setChartData({
      labels: Data.map((d) => d.label),
      datasets: [
        {
          label: label,
          data: Data.map((d) => d.number),
          backgroundColor: "rgba(26, 115, 232, 0.8)",
          borderColor: "transparent",
          borderRadius: 10,
          borderSkipped: false,
          barPercentage: 0.6,
        },
      ],
    });
  }, [Data]);

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    scales: {
      ...defaultOptions.scales,
      ...(options?.scales || {}),
    },
    plugins: {
      ...defaultOptions.plugins,
      ...(options?.plugins || {}),
    },
  };

  return chartData ? (
    <div style={{ position: "relative", height: "340px" }}>
      <Bar ref={chartRef} data={chartData} options={mergedOptions} plugins={[gradientPlugin]} />
    </div>
  ) : null;
};

export default BarChart;
